import { render, staticRenderFns } from "./ItemSlike.vue?vue&type=template&id=1ba2b9db&scoped=true"
import script from "./ItemSlike.vue?vue&type=script&lang=js"
export * from "./ItemSlike.vue?vue&type=script&lang=js"
import style0 from "./ItemSlike.vue?vue&type=style&index=0&id=1ba2b9db&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ba2b9db",
  null
  
)

export default component.exports